module.exports = __webpack_public_path__ + "img/图片1-1.0299898d.png";